import {
  mdiCommentQuestionOutline,
  mdiDelete,
  mdiFileFind,
  mdiFrequentlyAskedQuestions,
  mdiPencil,
  mdiPencilOutline,
  mdiPlus,
  mdiPlusBoxOutline,
} from '@mdi/js'

export default {
  aliases: {
    usage: mdiFileFind,
    plusBoxOutline: mdiPlusBoxOutline,
    commentQuestionOutline: mdiCommentQuestionOutline,
    pencilOutline: mdiPencilOutline,
    pencil: mdiPencil,
    delete: mdiDelete,
    plus: mdiPlus,
    question: mdiFrequentlyAskedQuestions,
  },
}
